import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import Breadcrumb from '../../Breadcrum.js';


export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Stapes (stapedectomy) Treatment & Surgery Cost in Delhi, India</title>
            <meta name="description" content="Get effective Stapes Surgery in Delhi, India, for hearing improvement. Learn about procedure, recovery, and surgery cost at MedFirst ENT Centre." />
            <meta name="keywords" content="stapes surgery Delhi, Stapedectomy procedure steps,Stapedectomy surgery cost,Stapes surgery set" />
            <link rel="canonical" href="https://entdelhi.com/stapes-surgery/" />
            <meta property="og:title" content="Stapes (stapedectomy) Treatment & Surgery Cost in Delhi, India" />
            <meta property="og:description" content="Get effective Stapes Surgery in Delhi, India, for hearing improvement. Learn about procedure, recovery, and surgery cost at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />   
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
